import { render, staticRenderFns } from "./allTask.vue?vue&type=template&id=375c627a&scoped=true&"
import script from "./allTask.vue?vue&type=script&lang=js&"
export * from "./allTask.vue?vue&type=script&lang=js&"
import style0 from "./allTask.vue?vue&type=style&index=0&id=375c627a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375c627a",
  null
  
)

component.options.__file = "allTask.vue"
export default component.exports